export class Dokument {
  selected: boolean;
  Beschreibung: string;
  BeschreibungKurz: string;
  DokumentTyp: string;
  VVGErforderlichJN: boolean;
}
